<template>
  <div>
    <div class="order">
      <div v-if="!isOpenBooking">
        <div class="route-info" :class="{ 'isCancelled': order.isAllCancelled }">
          <div class="route-info-l">
            <div class="route-info-hook" v-if="unpaidCount > 0" :class="{ active: isAllSelected() }"
              @click="selectAll()">
              <img src="https://resource.rcclchina.com.cn/tui2/user_center/list-selected.png">
            </div>
          </div>
          <div class="route-info-r">
            <a class="route-name external">{{ firstBookingItem.cruiseRoute }}</a>
            <div class="route-ship">{{ firstBookingItem.routeNights }} {{ firstBookingItem.shipName }}</div>
            <div class="route-row">
              <div class="route-row-title ">游轮往返</div>
              <div class="route-row-txt">：{{ firstBookingItem.sailDateBegin }} - {{ firstBookingItem.sailDateEnd }}
              </div>
            </div>
            <div class="route-row">
              <div class="route-row-title">联 系 人</div>
              <div class="route-row-txt">：{{ firstBookingItem.contactName }}</div>
            </div>
          </div>
          <div class="order-line"></div>
        </div>
        <div class="cabin-wrap" v-for="(booking, i) in bookingItems" :key="i">
          <router-link :to="getStatus(booking) !== 'cancel' ? { name: 'BookingDetail', query: { bookingId: booking.bookingId } } : ''" class="cabinItem"
            :class="{ active: isBookingSelected(booking) }">
            <div class="cabinItem-l">
              <div class="cabinItem-icon" v-if="isBookingUnPaid(booking)" @click.prevent="onBookingSelected(booking)">
                <img src="https://resource.rcclchina.com.cn/tui2/user_center/icon10.png">
              </div>
            </div>
            <div class="cabinItem-m" :class="{ 'isCancelled': getStatus(booking) === 'cancel' }">
              <div class="cabinItem-title">
                <div class="cabinItem-title-num">
                  <div class="cabinItem-title-num-txt1">船票预订号：</div>
                  <div class="cabinItem-title-num-txt2">{{ booking.bookingId }}</div>
                </div>
                <div v-if="getTikTokCouponStatus(booking.tikTokCouponStatus) && getStatusName(booking) !== '已取消'"
                  class="tik-tok-coupon-status common-ellipsis">
                  {{ getTikTokCouponStatus(booking.tikTokCouponStatus) }}<span
                    v-if="booking.tikTokRejectReason">({{ booking.tikTokRejectReason }})</span>
                </div>
                <div v-else class="tik-tok-coupon-status common-ellipsis">{{ getStatusName(booking) }}</div>
              </div>
              <div class="cabinItem-box external">
                <div class="cabinItem-img">
                  <img :src="booking.stateroomImage" />
                </div>
                <div class="cabinItem-info">
                  <div class="cabinItem-info-title">
                    <div class="cabinItem-info-title-l">{{ booking.stateroomCategoryName }}</div>
                    <!--                                    <div class="cabinItem-info-title-r">{{ getStatusName(booking) }}</div>-->
                  </div>
                  <div class="cabinItem-info-brief">{{ booking.areaInfo }} | {{ getBalconyArea(booking) }}</div>
                  <div class="cabinItem-info-num  ">
                    房号 {{ booking.stateroomNumber == 'GTY' ? '随机房' : booking.stateroomNumber }}
                    <img v-if="booking.groupType == 'QIAOHU' || booking.groupType == 'QIAOHU_AL'"
                      @click.prevent="onQiaohuRoomClicked(booking)" class="QIAOHU_CSS qiaohu_tag"
                      src="https://resource.rcclchina.com.cn/QIAOHU/Mobile_QIAOHU.jpg">
                    <img v-else-if="booking.groupType == 'STARRYSKY'" @click.prevent="onStarrySkyClicked(booking)"
                      class="STARRYSKY_CSS" src="https://resource.rcclchina.com.cn/STARRYSKY/MB_icon.png">
                    <img v-else-if="booking.groupType == 'PCPGIFT'"
                         @click.prevent="onCustomThemeClicked(booking)" class="PCP_GIFT_THEME_CSS"
                         :src="booking.personalizedStateroomInfo?.roomIconImage">
                    <img v-else-if="booking.groupType == 'CUSTOM'"
                         @click.prevent="onCustomThemeClicked(booking)" class="CUSTOM_THEME_CSS"
                         :src="booking.personalizedStateroomInfo?.roomIconImage">
                  </div>
                  <img v-if="booking.connectId && booking.connectId.length > 0" @click.prevent="onConnectRoomClicked()"
                    class="ConnectIcon_css"
                    src="https://resource.rcclchina.com.cn/ConnectStateroom/Mobile_ConnectIcon.png">
                  <div class="cabinItem-info-name">{{ booking.guestName }}</div>
                  <div v-if="booking.canEditGratuities && booking.isRow == false" class="gratuitiesLink">
                    <img class="icon" src="https://resource.rcclchina.com.cn/gratuities/iconPay.png" />
                    <div>预付服务费</div>
                    <img class="arrow" src="https://resource.rcclchina.com.cn/gratuities/iconArrow.png" />
                  </div>
                </div>
                <div class="invoiceLink" v-if="booking.showInvoiceLink && booking.isRow == false">
                  <div class="invoiceLink-con" @click.prevent="showInvoiceList(booking)">
                    <img src="https://resource.rcclchina.com.cn/wechatMiniProgram/invoice/iconInvoice.png" alt="">{{booking.invoiceStatusStr}}
                  </div>
                </div>
              </div>
              <div class="cabinItem-price">
                <div v-if="booking.upgradeCabinItem && booking.upgradeCabinItem.displayBiddingEntrance"
                  class="stateRoomBidding" @click.prevent="goToWxLink">
                  <img
                    v-if="booking.upgradeCabinItem.biddingStatus == 10 || booking.upgradeCabinItem.biddingStatus == 40 || booking.upgradeCabinItem.biddingStatus == 50"
                    src="https://resource.rcclchina.com.cn/wechatMiniProgram/bidding/bidding-success3.svg" alt="">
                  <img v-else src="https://resource.rcclchina.com.cn/wechatMiniProgram/bidding/bidding3.svg" alt="">
                  <div v-if="booking.upgradeCabinItem.canBidding">
                    <span v-if="booking.upgradeCabinItem.biddingStatus == 20">未竞价成功</span>
                    <span v-else>竞价升房</span>
                  </div>
                  <div v-if="!booking.upgradeCabinItem.canBidding">
                    <span
                      :style="booking.upgradeCabinItem.biddingStatus == 10 || booking.upgradeCabinItem.biddingStatus == 40 || booking.upgradeCabinItem.biddingStatus == 50 ? 'color: #5cb139' : ''">{{ getBiddingStatusText(booking.upgradeCabinItem.biddingStatus) }}</span>
                  </div>
                </div>
                <div v-if="booking.allowFillGuest" class="fill-guest-btn">
                  <span>补全乘客</span>
                  <img :src="`${imgUrl}/mobile/icons/icon-angle-right-orange.svg`" />
                </div>
                <div class="cabinItem-price-right">
                  <div class="cabinItem-price-txt1" v-if="getStatus(booking) == 'unpaid'">
                    <span class="grey">总计</span>
                    <span>{{ booking.currencyIcon }}</span>
                    {{ booking.amount }}
                  </div>
                  <div v-else-if="getStatus(booking) == 'unpaidFull' && (booking.total - booking.payAmount > 0)">
                    <div class="cabinItem-price-txt1 cabinItem-price-txt2">
                      <span class="grey">已付订金</span>
                      <span>{{ booking.currencyIcon }}</span>
                      {{ booking.payAmount }}
                    </div>
                    <div class="cabinItem-price-txt1">
                      <span class="grey">尾款</span>
                      <span>{{ booking.currencyIcon }}</span>
                      {{ getBalanceDue(booking) }}
                    </div>
                  </div>
                  <div class="cabinItem-price-txt1" v-else>
                    <span>{{ booking.currencyIcon }}</span>
                    {{ booking.amount }}
                  </div>
                </div>
                <div class="common-clr"></div>
              </div>
              <template v-if="getStatus(booking) !== 'cancel'">
                <div v-if="booking.unFilledGuest" class="cabinItem-un-filled-red">
                  <img class="icon" :src="`${imgUrl}/icons/icon-warning-red.png`" />
                  <div class="text">您有出行乘客未添加，请于开航45天前联系在线客服或致电400-8850-277补全。</div>
                </div>
                <div v-if="booking.allowFillGuest" class="cabinItem-un-filled">
                  <img class="icon" :src="`${imgUrl}/icons/icon-warning-triangle.png`" />
                  <div class="text">建议开航<span class="fc-red">45</span>天前补全全部乘客信息，开航前<span
                      class="fc-red">7</span>天及以内不可再进行修改</div>
                </div>
              </template>
            </div>
          </router-link>
          <div v-if="!booking.hasSubmittedSurvey" class="questionnaire" @click="toSurvey(booking.bookingRecordId)">
            <div class="scoreIcon">
              <img src="https://resource.rcclchina.com.cn/wechatMiniProgram/questionnaire/icons/pc_routeQNR.png" alt="">
            </div>
            <span>请对您的使用感受进行评分 >></span>
          </div>
        </div>
        <div class="" v-show="unpaidCount <= 0">
          <div class="order-feature" v-if="paidCount > 0">
            <a href="/Rccl.Olci/Olci/MobileNewCheckIn" class="order-feature-item external">
              <div class="order-feature-item-box">
                <img class="order-feature-item-icon7"
                  src="https://resource.rcclchina.com.cn/tui2/user_center/icon02.png">
                在线值船
              </div>
            </a>
            <router-link :to="cruiseDetailLink" class="order-feature-item external">
              <div class="order-feature-item-box">
                <img class="order-feature-item-icon3"
                  src="https://resource.rcclchina.com.cn/tui2/user_center/icon03.png">
                再来一单
              </div>
            </router-link>
          </div>
          <div class="order-feature" v-else-if="commentCount > 0">
            <router-link :to="cruiseSearchLink" class="order-feature-item external">
              <div class="order-feature-item-box">
                <img class="order-feature-item-icon7"
                  src="https://resource.rcclchina.com.cn/tui2/user_center/icon04.png">
                秀美图
              </div>
            </router-link>
            <router-link :to="cruiseDetailLink" class="order-feature-item external">
              <div class="order-feature-item-box">
                <img class="order-feature-item-icon3"
                  src="https://resource.rcclchina.com.cn/tui2/user_center/icon03.png">
                再来一单
              </div>
            </router-link>
          </div>
          <div class="order-feature" v-else-if="cancelCount > 0">
            <router-link to="/content/faq" class="order-feature-item external">
              <div class="order-feature-item-box">
                <img class="order-feature-item-icon6"
                  src="https://resource.rcclchina.com.cn/tui2/user_center/icon06.png">常见问题
              </div>
            </router-link>
            <router-link :to="cruiseSearchLinkSame" class="order-feature-item external">
              <div class="order-feature-item-box">
                <img class="order-feature-item-icon7"
                  src="https://resource.rcclchina.com.cn/tui2/user_center/icon07.png">找相似
              </div>
            </router-link>
            <router-link :to="cruiseDetailLink" class="order-feature-item external">
              <div class="order-feature-item-box">
                <img class="order-feature-item-icon3"
                  src="https://resource.rcclchina.com.cn/tui2/user_center/icon03.png">重新下单
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div v-if="isOpenBooking">
        <div class="route-info">
          <div class="route-info-l">
            <div class="route-info-hook openBookingHook" v-if="isBookingUnPaid(firstBookingItem)"
              :class="{ active: isOpenBookingSelected(firstBookingItem) }"
              @click="onOpenBookingSelected(firstBookingItem)">
              <img src="https://resource.rcclchina.com.cn/tui2/user_center/list-selected.png">
            </div>
          </div>
          <div class="route-info-r"><a class="route-name external">{{ firstBookingItem.openBookingTitle }}</a>
            <div class="route-ship">{{ firstBookingItem.openBookingSubTitle }}</div>
            <div class="route-row">
              <div class="route-row-title route-row-title-op"></div>
              <div class="route-row-txt"></div>
            </div>
          </div>

          <div class="order-line"></div>
        </div>
        <div class="cabin-wrap">
          <div class="cabinItem" :class="{ active: isOpenBookingSelected(firstBookingItem) }">
            <div class="cabinItem-l">
              <div class="cabinItem-icon" v-if="isBookingUnPaid(firstBookingItem)"
                @click="onOpenBookingSelected(firstBookingItem)">
                <img src="https://resource.rcclchina.com.cn/tui2/user_center/icon10.png">
              </div>
            </div>
            <div class="cabinItem-m">
              <div class="cabinItem-title">
                <div class="cabinItem-title-num" v-if="!isOpenBookingSendCoupon">
                  <div class="cabinItem-title-num-txt1">船票预订号：</div>
                  <div class="cabinItem-title-num-txt2">{{ firstBookingItem.bookingId ?
                    firstBookingItem.bookingId : '48小时内生成' }}</div>
                </div>
                <div class="cabinItem-title-num" v-else>
                  <div class="cabinItem-title-num-txt2">抵用券</div>
                </div>
              </div>
              <router-link
                :to="{ name: 'OpenBookingDetail', query: { 'orderId': firstBookingItem.openBookingOrderId } }"
                class="cabinItem-box external">
                <div class="cabinItem-img">
                  <img :src="firstBookingItem.stateroomImage" />
                </div>
                <div class="cabinItem-info">
                  <div class="cabinItem-info-title">
                    <div class="cabinItem-info-title-l">{{ firstBookingItem.guestName }}</div>
                    <div class="cabinItem-info-title-r">{{ getStatusName(firstBookingItem) }}</div>
                  </div>
                  <div class="openbooking-gift" v-if="isOpenBookingSendGift" @click.prevent="goToGift">
                    查看礼品
                  </div>
                  <div class="cabinItem-info-brief">
                    {{ firstBookingItem.contactGender == "M" ? '男' : '女' }}</div>
                  <div class="cabinItem-info-name"></div>
                </div>
              </router-link>
              <div class="cabinItem-price ">
                <div class="cabinItem-price-txt1">
                  <span>¥</span>
                  {{ firstBookingItem.amount }}
                </div>
              </div>

            </div>

            <div class="order-line"></div>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-bottom: 10px" v-if="bookingIntegrals > 0">
      <PointGiveaway :isImproveInfo="isFinishSelfInfo" :point="bookingIntegrals" @editInfo="editInfo"></PointGiveaway>
    </div>
  </div>
</template>

<script>
import bookingStatusHelper from '@/utilities/bookingStatusHelper'
import PointGiveaway from "@/components/Booking/PointGiveaway.vue";
import api from "@/api";
export default {
  name: "BookingListItem",
  components: { PointGiveaway },
  props: {
    order: {
      type: Object
    },
    selectedBooking: {
      type: Array
    },
    selectedOpenBooking: {
      type: Array
    },
    onBookingSelected: {
      type: Function
    },
    onOpenBookingSelected: {
      type: Function
    },
    onConnectRoomClicked: {
      type: Function
    },
    onQiaohuRoomClicked: {
      type: Function
    },
    onStarrySkyClicked: {
      type: Function
    },
    onCustomThemeClicked: {
      type: Function
    },
    orderItem: {
      type: Object,
      value: {}
    },
    userDetail: {
      value: ''
    }
  },
  data() {
    return {
      imgUrl: process.env.VUE_APP_IMG_URL,
    }
  },
  methods: {
    getStatusName(booking) {
      return bookingStatusHelper.getStatusName(booking)
    },
    getStatus(booking) {
      return bookingStatusHelper.getBookingStatus(booking)
    },
    getBalconyArea(booking) {
      if (!booking.balconyAreaInfo || booking.balconyAreaInfo == '' || booking.balconyAreaInfo == '无') {
        return '无阳台'
      }
      return booking.balconyAreaInfo
    },
    getBalanceDue(booking) {
      let balanceDue = booking.total - booking.payAmount;
      if (balanceDue > booking.balanceDue) {
        balanceDue = booking.balanceDue;
      }
      return balanceDue > 0 ? balanceDue.toFixed(0) : ""
    },
    isBookingUnPaid(booking) {
      const status = this.getStatus(booking)
      return status == 'unpaid' || status == 'unpaidFull'
    },
    isOpenBookingSelected(booking) {
      return this.selectedOpenBooking.some(r => r.openBookingOrderId == booking.openBookingOrderId)
    },
    isBookingSelected(booking) {
      return this.selectedBooking.some(r => r.bookingRecordId == booking.bookingRecordId)
    },
    isAllSelected() {
      let isAllSelected = true
      this.bookingItems.forEach((booking) => {
        if (!this.isBookingSelected(booking) && this.isBookingUnPaid(booking)) {
          isAllSelected = false
        }
      })
      return isAllSelected
    },
    selectAll() {
      if (this.isAllSelected()) {
        this.bookingItems.forEach((booking) => {
          if (this.isBookingSelected(booking) && this.isBookingUnPaid(booking)) {
            this.onBookingSelected(booking)
          }
        })
      } else {
        this.bookingItems.forEach((booking) => {
          if (!this.isBookingSelected(booking) && this.isBookingUnPaid(booking)) {
            this.onBookingSelected(booking)
          }
        })
      }
    },
    goToGift() {
      location.href = this.giftLink
    },
    getTikTokCouponStatus(status) {
      if (status === 1) {
        return "待审核"
      } else if (status === 3) {
        return "已拒绝"
      } else {
        return '';
      }
    },
    toSurvey(e) {
      this.$router.push({
        path: `/Rccl.CustomPage/questionnaire/SurveyQuestion`,
        query: {
          bookingRdId: e,
          pageFrom: 'order',
          type: 'HOME'
        }
      })
    },
    editInfo() {
      window.location.href = `/Rccl.UserCenter/CustomerInfo/EditInfo?returnUrl=${encodeURIComponent(
        location.href
      )}`
    },
    showInvoiceList(booking) {
      let status = booking.invoiceStatus
      if (status === 2 || status === 5) return
      if (status === 1) {
        this.$emit('showInvoiceList', booking)
      } else if (status === 3 || status === 4 || status === 6) {
        this.$router.push({
          path: '/Rccl.Booking/Booking/InvoiceDetailsProgress',
          query: {
            invoiceApplyId: booking.invoiceApplyId,
          }
        })
      }
    },
    // 跳转微信小程序
    async goToWxLink() {
      this.$loading.show();
      const { success, data, errMsg } = await api.booking.GetStateRoomUrlLink({ BookingRecordId: this.firstBookingItem.bookingRecordId });
      this.$loading.hide();
      if (success) {
        window.location.href = data
      } else {
        console.log(errMsg)
      }
    },
    getBiddingStatusText(biddingStatus) {
      switch (biddingStatus) {
        case 0:
          return '竞价升房中';
        case 10:
          return '竞价成功';
        case 20:
          return '未竞价成功';
        case 30:
          return '竞价升房';
        case 40:
          return '竞价成功未付款';
        case 50:
          return '竞价成功已付款';
        default:
          return '';
      }
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo
    },
    bookingItems() {
      if(this.order.bookingItems) {
        let allowInvoiceStatus = [1,3,4,6]
        this.order.bookingItems && this.order.bookingItems.forEach((row)=> {
          row.showInvoiceLink = allowInvoiceStatus.includes(row.invoiceStatus);
        })
      }
      return this.order.bookingItems || []
    },
    firstBookingItem() {
      return this.bookingItems.length > 0 ? this.bookingItems[0] : {}
    },
    isOpenBooking() {
      return bookingStatusHelper.isOpenBooking(this.firstBookingItem)
    },
    isOpenBookingSendCoupon() {
      return this.isOpenBooking && this.firstBookingItem.openBookingSendCoupon
    },
    isOpenBookingSendGift() {
      return this.isOpenBooking && this.firstBookingItem.openBookingSendGift
    },
    allStatus() {
      if (this.isOpenBooking) {
        return []
      }
      let result = []
      this.bookingItems.forEach((booking) => {
        result.push(bookingStatusHelper.getBookingStatus(booking))
      })
      return result
    },
    unpaidCount() {
      return this.allStatus.filter(r => r == 'unpaid' || r == 'unpaidFull').length
    },
    paidCount() {
      return this.allStatus.filter(r => r == 'paid').length
    },
    cancelCount() {
      return this.allStatus.filter(r => r == 'cancel').length
    },
    commentCount() {
      return this.allStatus.filter(r => r == 'noComment' || r == 'hasComment').length
    },
    cruiseDetailLink() {
      if (!this.firstBookingItem || !this.firstBookingItem.sailDate) {
        return ''
      }
      return '/Rccl.Cruise/CruiseDetail?shipCode=' + this.firstBookingItem.shipCode + '&sailDate=' + this.firstBookingItem.sailDate.split('T')[0]
    },
    cruiseSearchLink() {
      var sailDays = parseInt(this.firstBookingItem.sailDays);
      if (sailDays <= 3) {
        sailDays = 3;
      } else if (sailDays >= 4 && sailDays <= 5) {
        sailDays = 4;
      } else if (sailDays >= 6) {
        sailDays = 6;
      }
      const search = '/Rccl.Cruise/CruiseSearch/Search?departureCodes=' + this.firstBookingItem.cruiseDeparture + '&sailDays=' + sailDays;
      return search
    },
    cruiseSearchLinkSame() {
      let arr = this.bookingItems.filter(booking => booking.isRow == true)
      let isRow = arr.length > 0
      var sailDays = parseInt(this.firstBookingItem.sailDays);
      if (sailDays <= 3) {
        sailDays = 3;
      } else if (sailDays >= 4 && sailDays <= 5) {
        sailDays = 4;
      } else if (sailDays >= 6) {
        sailDays = 6;
      }
      const search = `/Rccl.Cruise/CruiseSearch/${isRow == false ? 'Search':'SearchRow'}?departureCodes=` + this.firstBookingItem.cruiseDeparture + '&sailDays=' + sailDays;
      return search
    },
    giftLink() {
      const giftLink = `${process.env.VUE_APP_REWARD_URL}/reward/member/shop/gift`
      if (this.userInfo && this.userInfo.userIdentity == 1) {
        return `${giftLink}?token=${this.userInfo.localRewardToken}`
      } else {
        return `/Rccl.UserCenter/CustomerInfo/SignupReward?returnUrl=${encodeURIComponent(giftLink)}`
      }
    },
    isLocalReward() {
      return (
        this.userDetail &&
        this.userDetail.memberLevelStr &&
        this.userDetail.memberLevelStr.length > 0
      );
    },
    isFinishSelfInfo() {
      return this.isLocalReward && this.userDetail.infoIntegrity == 100;
    },
    bookingIntegrals() {
      let integrals = 0;
      this.bookingItems.forEach((booking) => {
        if (booking.bookingIntegrals && booking.bookingIntegrals.length > 0) {
          booking.bookingIntegrals.forEach(item => {
            integrals += Number(item.integral);
          })
        }
      });
      return integrals;
    }
  }
}
</script>

<style lang="less" scoped>
img {
  max-width: 100%;
}

.order {
  width: 355px;
  margin: 0 auto 10px;
  padding: 0 10px;
  border-radius: 5px;
  background-color: #fff;
  border: 1px solid #FEBC10;
  border-top: 5px solid #FEBC10;
  -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
}

.order-line {
  width: 100%;
  height: 1px;
  background: url(https://resource.rcclchina.com.cn/tui2/user_center/order_line.png) repeat-x;
  -webkit-background-size: auto 100%;
  -o-background-size: auto 100%;
  background-size: auto 100%;
}

.route-info {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  padding: 11px 0 4px;
  &.isCancelled div,
  &.isCancelled a {
    color: #b9b9b9;
  }
}

.route-info-l {
  -webkit-box-flex: 0;
  -webkit-flex: none;
  -moz-box-flex: 0;
  -ms-flex: none;
  flex: none;
  width: 15px;
  margin-right: 5px;
}

.route-info-hook {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -moz-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 15px;
  height: 15px;
  margin-top: 3px;
  border: 1px solid #4A90E2;
  border-radius: 100%;
}

.route-info-hook img {
  display: none;
  width: 12px;
}

.route-info-hook.active {
  background-color: #4A90E2;
}

.route-info-hook.active img {
  display: block;
}

.route-info-r {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -moz-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.route-name {
  display: block;
  padding-bottom: 5px;
  font-size: 14px;
  line-height: 20px;
  color: #333;
  font-weight: bold;
}

.route-name .badge {
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -moz-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 15px;
  margin-left: 6px;
  padding: 0 7px;
  font-size: 10px;
  line-height: 1;
  color: #fff;
  background-color: #FAC400;
  border-radius: 14px;
}

.route-name .badge img {
  width: 13px;
}

.route-ship {
  padding-bottom: 7px;
  font-size: 12px;
  line-height: 16px;
  color: #666;
}

.route-ship p {
  margin: 0px;
}

.route-row {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding-bottom: 6px;
}

.route-row-title {
  -webkit-box-flex: 0;
  -webkit-flex: none;
  -moz-box-flex: 0;
  -ms-flex: none;
  flex: none;
  width: 48px;
  font-size: 12px;
  line-height: 16px;
  color: #666;
}

.route-row-title-op {
  width: auto;
}

.route-row-txt {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -moz-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  font-size: 12px;
  line-height: 12px;
  color: #151515;
}

.route-info .order-line {
  position: absolute;
  left: 0;
  bottom: 0;
}



.cabinItem {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
}

.cabinItem-m {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -moz-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  &.isCancelled div {
    color: #b9b9b9 !important;
  }
}

.cabinItem-title {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 12px 0;
}

.tik-tok-coupon-status {
  font-size: 12px;
  max-width: 48%;
}

.cabinItem-title-num {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -moz-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  font-size: 14px;
  line-height: 18px;
  font-weight: bold;
}

.cabinItem-title-num-txt1 {
  margin-right: 0;
  color: #4A90E2;
}

.cabinItem-title-num-txt2 {
  margin-right: 5px;
  color: #151515;
}

.cabinItem-title-status {
  -webkit-box-flex: 0;
  -webkit-flex: none;
  -moz-box-flex: 0;
  -ms-flex: none;
  flex: none;
  font-size: 10px;
  line-height: 14px;
  color: #4A90E2;
}

.cabinItem-box {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  //padding-bottom: 13px;
}
.invoiceLink{
  display: flex;
  align-items: flex-end;
  font-size: 12px;
  color: #317FDC;
  line-height: 20px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}
.invoiceLink-con{
  display: flex;
  align-items: center;
  gap: 4px;
}
.invoiceLink img{
  width: 14px;
  height: 11px;
}
.cabinItem-img {
  -webkit-box-flex: 0;
  -webkit-flex: none;
  -moz-box-flex: 0;
  -ms-flex: none;
  flex: none;
  width: 100px;
  margin-right: 12px;

  &>img {
    display: block;
  }
}

.cabinItem-info {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -moz-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  position: relative;
}

.cabinItem-info-title {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  padding-bottom: 5px;
  color: black;
  font-weight: bold;
  font-size: 14px;
}

.cabinItem-info-title-l {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -moz-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  padding-right: 4px;
  font-size: 12px;
  line-height: 16px;
  color: #333;
  font-weight: bold;
}

.cabinItem-info-title-r {
  -webkit-box-flex: 0;
  -webkit-flex: none;
  -moz-box-flex: 0;
  -ms-flex: none;
  flex: none;
  font-size: 12px;
  line-height: 16px;
  color: #4A90E2;
}

.openbooking-gift {
  line-height: 16px;
  right: 0;
  top: 21px;
  position: absolute;
  width: 100px;
  height: 30px;
  text-align: right;
  color: #4A90E2;
  font-size: 12px;
  font-weight: 700;
  text-decoration: underline;
}

.cabinItem-info-brief {
  padding-bottom: 5px;
  font-size: 12px;
  line-height: 16px;
  color: #666;
}

.cabinItem-info-num {
  padding-bottom: 20px;
  font-size: 12px;
  line-height: 16px;
  color: #666;
}

.HasQiaoHu,
.HasConnectImg {
  padding-bottom: 5px;
}

.cabinItem-info-name {
  font-size: 12px;
  line-height: 16px;
  color: #666;
}

.cabinItem-serve {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  padding-bottom: 16px;
  font-size: 12px;
  line-height: 16px;
}

.cabinItem-serve-title {
  -webkit-box-flex: 0;
  -webkit-flex: none;
  -moz-box-flex: 0;
  -ms-flex: none;
  flex: none;
  margin: 0;
  color: #2A2A2A;
}

.cabinItem-serve-txt {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -moz-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  margin: 0;
  color: #666;
}

.cabinItem-price {
  margin-left: 112px;
  padding-bottom: 12px;
  display: flex;
  align-items: flex-end;
  flex-direction: column;

  & .cabinItem-price-right {}

  .stateRoomBidding {
    font-size: 12px;
    color: #317fdc;
    display: flex;
    align-items: center;
    gap: 3px;

    img {
      width: 12px;
      height: 12px;
    }
  }
}

.cabinItem-price-txt1 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: baseline;
  -webkit-align-items: baseline;
  -moz-box-align: baseline;
  -ms-flex-align: baseline;
  align-items: baseline;
  font-size: 15px;
  line-height: 20px;
  color: #FF5055;
  font-weight: bold;

}

.cabinItem-price-txt1 span {
  display: block;
  margin-right: 3px;
  font-size: 12px;
}

.cabinItem-price-txt1 .grey {
  color: #666;
  font-weight: normal;
}

.cabinItem-price-txt2 {
  margin-right: 11px;
  color: #666;
  font-weight: normal;
}

.cabinItem-l {
  -webkit-box-flex: 0;
  -webkit-flex: none;
  -moz-box-flex: 0;
  -ms-flex: none;
  flex: none;
  width: 15px;
  margin-top: 13px;
  margin-right: 5px;
}

.cabinItem-icon {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -moz-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 15px;
  height: 15px;
  border: 1px solid #4A90E2;
  border-radius: 100%;
}

.cabinItem-icon img {
  display: none;
  width: 12px;
}

.cabinItem.active .cabinItem-icon {
  background-color: #4A90E2;
}

.cabinItem.active .cabinItem-icon img {
  display: block;
}

.cabinItem .order-line {
  position: absolute;
  left: 0;
  bottom: 0;
}

.cabinItem:last-child .order-line {
  display: none;
}

.order-feature {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-top: 1px solid #E5E5E5;
}

.order-feature-item {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -moz-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -moz-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 16px 0;
  font-size: 12px;
  line-height: 14px;
  color: #4A90E2;
}

.order-feature-item-box {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -moz-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 100%;
}

.order-feature-item .order-feature-item-box {
  border-left: 1px solid #ccc;
}

.order-feature-item:first-child .order-feature-item-box {
  border-left: none;
}

.order-feature-item-icon1 {
  display: block;
  width: 8px;
  margin-right: 3px;
}

.order-feature-item-icon2 {
  display: block;
  width: 16px;
  margin-right: 1px;
}

.order-feature-item-icon3 {
  display: block;
  width: 12px;
  margin-right: 3px;
}

.order-feature-item-icon4 {
  display: block;
  width: 12px;
  margin-right: 4px;
}

.order-feature-item-icon5 {
  display: block;
  width: 11px;
  margin-right: 3px;
}

.order-feature-item-icon6 {
  display: block;
  width: 11px;
  margin-right: 4px;
}

.order-feature-item-icon7 {
  display: block;
  width: 12px;
  margin-right: 4px;
}

.orderRecord-link {
  position: fixed;
  bottom: 20%;
  right: 0;
  z-index: 2222;
  padding: 4px 4px 4px 10px;
  font-size: 10px;
  line-height: 14px;
  color: #fff;
  background-color: #4A90E2;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
}

.ConnectIcon_css {
  background-size: 100% 100%;
  width: 113px;
}

.QIAOHU_CSS {
  background-size: 100% 100%;
  width: 113px;
  display: block;
  margin-top: 5px;
}

.STARRYSKY_CSS {
  background-size: 100% 100%;
  width: 113px;
  display: block;
  margin-top: 5px;
}

.PCP_GIFT_THEME_CSS {
  background-size: 100% 100%;
  width: 90px;
  display: block;
  margin-top: 5px;
}

.CUSTOM_THEME_CSS {
  background-size: 100% 100%;
  width: 90px;
  display: block;
  margin-top: 5px;
}
.fill-guest-btn {
  font-size: 12px;
  float: left;
  display: block;
  margin-top: 2px;
  color: #ED9100;

  &>img {
    height: 8px;
    margin-left: 2px;
  }

  &:hover {
    background-color: #e1f1ff;
  }

  &:active {
    background-color: #EEF5FB;
  }
}

.cabinItem-un-filled {
  overflow: hidden;
  font-size: 12px;
  color: #4A90E2;
  padding-bottom: 12px;

  & .icon {
    height: 12px;
    float: left;
    margin-right: 4px;
    margin-top: 2px;
  }

  & .text {
    line-height: 18px;
    overflow: hidden;
    letter-spacing: -1px;
  }
}

.questionnaire {
  //width: 90%;
  padding: 0 8px 0;
  height: 33px;
  //color: #1464F0;
  text-align: center;
  display: flex;
  align-items: center;
  font-family: PingFangSC-Regular, PingFang SC, serif;
  font-weight: 400;
  font-size: 12px;
  gap: 3px;
  background-color: rgba(220, 235, 255, 1);
  margin-bottom: 10px;

  //margin-left: 10px;
  span {
    height: 20px;
    cursor: pointer;
    color: #006ab5;
    text-decoration: none;
  }

  .scoreIcon {
    width: 15px;
    height: 15px;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.cabinItem-un-filled-red {
  display: flex;
  align-items: flex-start;
  font-size: 12px;
  color: #ff2742;
  padding: 5px 10px;
  background-color: #fff1f1;
  margin-bottom: 12px;

  & .icon {
    height: 12px;
    float: left;
    margin-right: 4px;
    margin-top: 2px;
  }

  & .text {
    line-height: 18px;
    overflow: hidden;
  }
}

.gratuitiesLink {
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 1;
  margin-top: 6px;
  gap: 3px;
  color: #006AB6;

  & img {
    display: block;
  }

  & .icon {
    height: 15px;
    width: 15px;
  }

  & .arrow {
    height: 8px;
    width: 4px;
  }
}
</style>
